const ICCSRESPONSEDATA = () =>localStorage.getItem('iccs_response');

export default ICCSRESPONSEDATA;